/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Round_TimeInputs */



/**
* | output |
* | --- |
* | "Round time" |
*
* @param {Timer_Round_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_round_time = /** @type {((inputs?: Timer_Round_TimeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Round_TimeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tempo de rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo del round")
	return /** @type {LocalizedString} */ ("Round time")
});